// extracted by mini-css-extract-plugin
export default {"timeoutWarningContainer":"timeoutWarning_timeoutWarningContainer","timeoutWarningBodyMessage":"timeoutWarning_timeoutWarningBodyMessage"};